import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import { ConvertCloudyToClassicSource } from './schema/ConvertCloudyToClassicSource';

export default {
    AttachmentSaveToCloud: {
        datapoint: {
            name: 'AttachmentSaveToCloud',
            customData: (size: number, result: AttachmentResultCode) => [size, result],
        },
    },
    AttachmentConvertClassicToCloudy: {
        datapoint: {
            name: 'AttachmentConvertClassicToCloudy',
            customData: (size: number, result: AttachmentResultCode) => [size, result],
        },
    },
    CancelConvertClassicToCloudy: {
        datapoint: {
            name: 'CancelConvertClassicToCloudy',
        },
    },
    AttachmentConvertCloudyToClassic: {
        datapoint: {
            name: 'AttachmentConvertCloudyToClassic',
            customData: (
                size: number,
                result: AttachmentResultCode,
                generatedAttachmentId: string, // used for tracking actions on a particular attachment)
                source: ConvertCloudyToClassicSource
            ) => [size, result, generatedAttachmentId, source],
        },
    },
    CancelConvertCloudyToClassic: {
        name: 'CancelConvertCloudyToClassic',
    },
};
